import { myAxios } from "./axios";

export function getAllInsurances(data, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(data || {}),
    },
  };
  return myAxios.get("/insurances", config);
}

export function getSingleInsurance(id) {
  return myAxios.get("/insurances/" + id);
}

export function addInsurance(data) {
  return myAxios.post("/insurances/create", data);
}

export function editInsurance(id, data) {
  return myAxios.put("/insurances/update/" + id , data);
}

export function deleteInsurance(id) {
  return myAxios.delete("/insurances/delete/" + id );
}
